import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class QuoteService {
  

    constructor(public firestore: AngularFirestore) {
    }

    public getCollection(customerId: string): AngularFirestoreCollection {
        return this.firestore.collection(`customers/${customerId}/quotes`)
    }

    deleteQuote(customerId: string, quoteId: string) {
        if (quoteId && customerId) {
            return this.firestore.collection('customers').doc(customerId).collection('quotes').doc(quoteId).delete().then(() => { return true });
        }
        return false;
    }

    async updateQuote(customerId: string, quoteId: string, quote: any) {
        return await this.firestore.collection('customers').doc(customerId).collection('quotes').doc(quoteId).update(quote)
    }

    public async getCustomerById(customerId = 'doXpoRCw3r1mp7w37mDm') {
        return (await this.firestore.collection('customers').doc(customerId).ref.get()).data()
    }

    public async getCustomerQuoteById(customerId = 'doXpoRCw3r1mp7w37mDm', quoteId = 'W9Mr2R6XNMk6GL6uDIOS') {
        return (await (await this.firestore.collection('customers').doc(customerId).collection('quotes').doc(quoteId).get()).toPromise()).data()
    }

    async addQuote(customerId: string, quote: any) {
       return  await this.firestore.collection(`customers/${customerId}/quotes`).add(quote)
      }
}